export const ReportFilterLabels = {
    _is: 'es',
    beginDate: 'Fecha de inicio',
    colon: ':',
    datesRangeType: 'Rango de fechas',
    endDate: 'Fecha de fin',
    maxDays: 30,
    placeholderCarrier: 'Línea de transporte',
    required: 'requerido',
    search: 'Buscar',
    titleCard: 'Búsqueda',
    zero: 0,
  };
